module.exports = __webpack_public_path__ + "static/media/coxinhacatupiry.2cc736e5.webp";